import { styled } from '@mui/material';
import { Box } from '@mui/system';

export const Absolute = styled(Box)({
  position: 'absolute'
});
